'use strict';
module.exports = function unixTimestamp(date) {
	const dt = date || new Date(),
		jsTs = dt.getTime && dt.getTime();
	return jsTs && Math.floor(jsTs / 1000);
};

